import type { TaskComment } from '@/task-manager/entities/task-comment';

import type { GetCardDetailViewOutputCommentRead } from '../fetch-client';

export function taskCommentMapper(
  data: GetCardDetailViewOutputCommentRead,
): TaskComment {
  return {
    id: data.uuid,
    content: data.content,
    user: { name: data.user_name, email: data.user_email },
    createdAt: new Date(data.created_at),
    modified: Boolean(data.modified_at) || data.modified,
  };
}
